import { render, staticRenderFns } from "./DetalleHospi.vue?vue&type=template&id=c57dfed8"
import script from "./DetalleHospi.vue?vue&type=script&lang=js"
export * from "./DetalleHospi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports